// Copyright (c) StrangeBee 2023

import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import THTable from '@Molecules/THTable/THTable';
import DisplayTag from '@Organisms/DisplayTag/DisplayTag';
import React, { ReactElement } from 'react';
import { TagOutput } from 'thehive-sdk';
import { TitleSection } from '@Atoms/TitleSection/TitleSection';
import { ExtractProps } from '@Molecules/Details/Details';
import { ColumnTitle } from '@Atoms/ColumnTitle/ColumnTitle';
import { ICONS } from '@Constants/iconsApp';

interface ExtractDataProps {
    locale: (...args: any[]) => any;
}

export const extractData = ({ locale }: ExtractDataProps): Record<any, ExtractProps> => ({
    namespace: {
        name: locale('taxonomy.preview.header.namespace'),
    },
    version: {
        name: locale('taxonomy.preview.header.version'),
    },
    description: {
        name: locale('taxonomy.preview.header.description'),
    },
    tags: {
        name: <TitleSection>{locale('common.tags')}</TitleSection>,
        className: 'taxonomie-details__tags',
        render: (tags: TagOutput[]) => {
            const orderedTags = tags.sort((a, b) => a.predicate.localeCompare(b.predicate));

            return (
                <THTable
                    dataSource={orderedTags}
                    rowKey="_id"
                    columns={[
                        {
                            title: <ColumnTitle>{locale('taxonomy.preview.columns.tag')}</ColumnTitle>,
                            className: 'custom-table__cell',
                            width: '40%',
                            render: (_, tag): ReactElement => <DisplayTag tag={tag} />,
                        },
                        {
                            title: <ColumnTitle>{locale('taxonomy.preview.columns.predicate')}</ColumnTitle>,
                            className: 'custom-table__cell',
                            width: '20%',
                            render: (_, { predicate }): ReactElement => <>{predicate}</>,
                        },
                        {
                            title: <ColumnTitle>{locale('taxonomy.preview.columns.value')}</ColumnTitle>,
                            className: 'custom-table__cell',
                            width: '30%',
                            render: (_, { value }): ReactElement => <>{value || '-'}</>,
                        },
                        {
                            title: <ColumnTitle>{locale('taxonomy.preview.columns.color')}</ColumnTitle>,
                            className: 'custom-table__cell',
                            width: '9%',
                            render: (_, { colour }): ReactElement => <>{colour}</>,
                        },
                        {
                            width: '1%',
                            render: (_, { description }): ReactElement | null =>
                                description ? (
                                    <THTooltip title={description}>
                                        <ICONS.QuestionCircleFilled />
                                    </THTooltip>
                                ) : null,
                        },
                    ]}
                    loading={false}
                />
            );
        },
    },
});
